import './sharedmodules/common-utility/styles/base-styles.scss';
import JDWarrantyRoutes from './configmodules/routing/routes';
import React from 'react';

function App() {

    return (
        <div>
            <JDWarrantyRoutes />
        </div>
    );

}

export default App;
